/**
 * Salvataggio di un file scaricato dal server.
 *
 * Passa da un `<a download>` invece che da `window.open`: il file arriva con
 * `Content-Disposition: attachment`, e aprirlo in una scheda lo farebbe
 * scaricare comunque ma lasciando in giro una scheda vuota da chiudere.
 */
export function saveBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  document.body.append(anchor);
  anchor.click();
  anchor.remove();

  // Il rilascio va rimandato: revocare subito l'URL annulla il download su
  // alcuni browser, che non hanno ancora finito di leggerlo.
  window.setTimeout(() => URL.revokeObjectURL(url), 30_000);
}

/** Nome file di ripiego, se il server non lo dichiara. */
export function fallbackExportName(eventName: string, isoDate: string): string {
  const slug = eventName
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60);

  return `${slug || 'evento'}_riepilogo_${isoDate}.xlsx`;
}
